<template>
  <v-dialog :modelValue="open" max-width="600" @click:outside="$emit('cancel')" @keydown.esc="$emit('cancel')">
    <v-card>
      <!-- El v-form es para que tome el estilo de titulo de los modales (_general.scss) -->
      <v-form @submit.prevent>
        <v-card-title>
          <span class="headline">Generar reposición</span>
        </v-card-title>

        <v-card-text>
          <p class="mt-3 mb-4 fs-16">
            ¿Confirma iniciar la generación de tareas de reposición para todos los almacenes? El proceso corre en segundo plano y puede tardar varios minutos.
          </p>

          <v-select
            v-model="selected"
            :items="tipos_ubicacion"
            :item-title="tipoUbicacionLabel"
            item-value="id"
            label="Tipos de ubicación de origen"
            :loading="loading_tipos"
            :disabled="loading_tipos"
            multiple
            chips
            closable-chips
          ></v-select>

          <p class="text-caption text-medium-emphasis mb-0">La selección aplica solo a esta corrida: no modifica la configuración de los tipos de ubicación.</p>
          <p class="text-caption text-medium-emphasis mb-0">Los almacenes de sucursales sin tipos seleccionados no generarán tareas.</p>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn color="red darken-1" text @click="$emit('cancel')"> No </v-btn>

          <v-btn color="green darken-1" text :loading="loading" :disabled="selected.length == 0" @click="$emit('accept', selected)"> Si </v-btn>
        </v-card-actions>
      </v-form>
    </v-card>
  </v-dialog>
</template>
<script>
import { tipoUbicacionService } from "@/libs/ws/tipoUbicacionService";

export default {
  props: {
    open: Boolean,
    loading: {
      default: false,
      type: Boolean,
    },
  },
  emits: ["cancel", "accept"],
  data() {
    return {
      tipos_ubicacion: [],
      selected: [],
      loading_tipos: false,
    };
  },
  watch: {
    open() {
      if (this.open) this.loadTiposUbicacion();
    },
  },
  methods: {
    //Se recarga en cada apertura: la seleccion vale para una sola corrida
    loadTiposUbicacion() {
      this.tipos_ubicacion = [];
      this.selected = [];
      this.loading_tipos = true;

      tipoUbicacionService
        .filter({})
        .then((response) => {
          if (!response.status) {
            this.toast.error(response.msg);
            return;
          }
          this.tipos_ubicacion = response.result.list;
          //Mismo criterio que el cron de las 01:00: confirmar sin tocar nada da el mismo filtro
          this.selected = this.tipos_ubicacion.filter((t) => t.allow_reposicion && !t.allow_picking).map((t) => t.id);
        })
        .catch((e) => {
          this.toast.error(e);
        })
        .finally(() => {
          this.loading_tipos = false;
        });
    },
    //El nombre se puede repetir entre sucursales: se agrega la sucursal para distinguirlos
    tipoUbicacionLabel(tipo) {
      if (tipo == null || typeof tipo !== "object") return tipo;
      return tipo.sucursal && tipo.sucursal.name ? tipo.name + " (" + tipo.sucursal.name + ")" : tipo.name;
    },
  },
};
</script>
